import { SubjectReviewState } from '../initial.state';
import { SubjectReviewActionTypes } from '../actions/subjectReview.action';

function SubjectReviewReducer(state = new SubjectReviewState(), action) {
  switch (action.type) {
    case SubjectReviewActionTypes.ALL_FINISHED_SUBJECTS_SUCCESS:
      return {
        ...state,
        finishedSubjects: action.payload.data,
      };

    default:
      return {
        ...state,
      };
  }
}

export { SubjectReviewReducer };
